import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {useOrderInvoiceFormContext} from '../../contexts/OrderInvoiceFormContext';
import {PopupReplaceInvoiceContextProvider} from '../../contexts/PopupReplaceInvoiceContext';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import ModalPopup from '../../../../common/components/ui/ModalPopup';
import PopupReplaceInvoice from '../PopupReplaceInvoice';
import styles from './PopupSelectAction.module.scss';

const PopupSelectAction = () => {
  const context = useGlobalContext();
  const {
    showSelectAction,
    closePopupSelectAction,
    handleClick,
    handleSubmitAdditional,
    isSubmitting
  } = useOrderInvoiceFormContext();

  return (
    <>
      <div className={styles.buttonSubmitContainer}>
        <ButtonAction
          variant={'button'}
          label={<FormattedMessage id={'orderInvoice-form-submit'} defaultMessage={'Confirm & send'}/>}
          onClick={() => handleClick()}
          disabled={isSubmitting}
        />
      </div>
      <ModalPopup
        isOpen={showSelectAction}
        onRequestClose={closePopupSelectAction}
        customModalStyles={styles.modal}
      >
        <div className={styles.popupSelectActionContainer} dir={context.layoutDirection}>
          <div className={styles.title}>
            <FormattedMessage
              id={'orderInvoice-form-select-action-title-1'}
              defaultMessage={'The system has detected that an invoice has already been generated for this customer this month.'}
            />
          </div>
          <div className={styles.title}>
            <FormattedMessage
              id={'orderInvoice-form-select-action-title-2'}
              defaultMessage={'Please indicate whether the invoice you are requesting is an addition to or a replacement for an existing invoice?'}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <PopupReplaceInvoiceContextProvider>
              <PopupReplaceInvoice/>
            </PopupReplaceInvoiceContextProvider>
            <ButtonAction
              variant={'button'}
              label={<FormattedMessage id={'orderInvoice-form-submit-additional'} defaultMessage={'This invoice is additional'}/>}
              onClick={async () => await handleSubmitAdditional()}
              customClassnames={{container: styles.buttonContainer}}
            />
            <ButtonAction
              variant={'reject'}
              label={<FormattedMessage id={'orderInvoice-form-cancel'} defaultMessage={'Cancel'}/>}
              onClick={closePopupSelectAction}
              customClassnames={{container: styles.buttonContainer}}
            />
          </div>
        </div>
      </ModalPopup>
    </>
  );
};

export default PopupSelectAction;
